import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { MicrosoftSecurityGroup, MicrosoftSecurityGroupResult } from '../../shared/models/generated/ziroModels';

export interface TenantMicrosoftSecurityGroup extends MicrosoftSecurityGroup {
  tenantId: string;
}

export interface TenantMicrosoft365SecurityGroupResult extends MicrosoftSecurityGroupResult {
  tenantId: string;
}

@Injectable()
export class MicrosoftSecurityGroupsTenantSearchResource {
  private _http = inject(HttpClient);

  get(tenantId: string, name: string): Observable<TenantMicrosoftSecurityGroup> {
    return this._http
      .get<MicrosoftSecurityGroup>(`/services/microsoft/macs/tenants/${tenantId}/security-groups/${name}`)
      .pipe(map((result) => ({ ...result, tenantId })));
  }

  search(tenantId: string, query: string, assignedOnly: boolean): Observable<TenantMicrosoft365SecurityGroupResult[]> {
    return this._http
      .get<
        MicrosoftSecurityGroupResult[]
      >(`/services/microsoft/macs/tenants/${tenantId}/security-groups/search?q=${encodeURIComponent(query)}&assignedOnly=${assignedOnly}`)
      .pipe(map((results) => results.map((result) => ({ ...result, tenantId }))));
  }
}
